import React from 'react';
import Hero from 'components/organisms/Hero/Hero';
import LandingPageContent from 'components/organisms/LandingPageContent/LandingPageContent';
import HeroSignUpForm from 'components/organisms/Hero/HeroSignUpForm';
import Txt from 'components/atoms/Txt/Txt';
import classes from './Homepage.module.scss';
import Heading from 'components/atoms/Heading/Heading';

export interface Props {}

const Homepage: React.FC<Props> = () => {
  return (
    <main>
      <Hero
        leftColumnContent={
          <div className={classes.root}>
            <Heading level="2" className={classes.subtitle}>
              Kill Time, Productively
            </Heading>
            <Heading uppercase level={1} className={classes.mainTitle}>
              Earn{' '}
              <Txt component="strong" color="secondary" uppercase>
                real cash
              </Txt>{' '}
              with paid online surveys
            </Heading>
            <Txt component="p" className={classes.description}>
              Forget swag or points - withdraw your <Txt component="strong">cash instantly</Txt>{' '}
              with Qmee.
            </Txt>
          </div>
        }
        rightColumnContent={
          <>
            <HeroSignUpForm />
          </>
        }
      />
      <LandingPageContent />
    </main>
  );
};

export default Homepage;
